/**
 * Erreur dont le message (en français) peut être montré tel quel à l'utilisateur.
 * Toute autre erreur (Firebase, réseau, navigateur…) est technique : l'interface
 * affiche alors un message générique et la journalise.
 */
export class UserFacingError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'UserFacingError';
    }
}

/** Message affichable : celui d'une UserFacingError, sinon `fallback`. */
export function userMessage(error: unknown, fallback: string): string {
    return error instanceof UserFacingError ? error.message : fallback;
}

/**
 * Échec de chargement d'un morceau de l'application (import dynamique) : en
 * pratique, une nouvelle version a été déployée pendant que la page était ouverte.
 */
export function isChunkLoadError(error: unknown): boolean {
    if (!(error instanceof Error)) return false;
    return error.name === 'ChunkLoadError'
        // Chrome / Firefox : « … dynamically imported module », Safari : « Importing a module script failed ».
        || /dynamically imported module|importing a module script failed/i.test(error.message);
}
